var f = Object.defineProperty;
var d = (r, e, n) => e in r ? f(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
var o = (r, e, n) => d(r, typeof e != "symbol" ? e + "" : e, n);
import "oidc-client";
import "lodash-es";
import "nanoid";
import "../../../date-D-6ewr4B.mjs";
import { A as p } from "../../../api-CZJ4bXCT.mjs";
import "../../../styled-qu50FBLM.mjs";
import "../../../utils/globalStyles.js";
import { EnvironmentService as u } from "../environmentService/environmentService.js";
const t = class t {
  /**
   * Constructor will build the baseURL using the current environment or provided override and configure the API apdator to post feedback
   * @param env optional override to target a different user feedback subdomain instead of using the current environment
   */
  constructor(e) {
    o(this, "adapter");
    this.adapter = new p({
      baseURL: this.getUrlForEnvironment(e ?? u.currentEnvironment ?? "prod"),
      responseType: "json",
      headers: {
        timeout: 60 * 10 * 1e3,
        "content-type": "application/json",
        accept: "application/json"
      }
    });
  }
  /**
   * Builds the payload for the user feedback service API in the transaction-services subdomain and posts the request
   * @param request object containing parameters provided by the CompletionSurvey UI component to build the UserFeedback api request
   */
  async sendFeedback(e) {
    const n = this.getUserBrowser(), i = this.getUserOS(), s = {
      id: e.transactionID,
      transaction: e.transaction,
      thumbsUp: e.thumbsUp,
      message: e.message,
      browser: n,
      operatingSystem: i
    };
    await this.adapter.postValue(t.urlEndpoint, s);
  }
  /**
   * Selects the appropriate subdomain based on user environment and builds the user feedback request URL
   * (env = uat example: https://uat.feedback.transaction-services-nonprod.service.vic.gov.au)
   *
   * @param env the active environment to construct the transaction-services URL from
   * @returns the fully built URL target for the user feedback API request
   */
  getUrlForEnvironment(e) {
    const n = e.indexOf("prod") !== -1, i = e.indexOf("stage") !== -1, s = n || i ? "transaction-services" : "transaction-services-nonprod";
    return `https://${`${n ? "api" : e}`}.feedback.${s}.service.vic.gov.au`;
  }
  /**
   * Retrieve the user's browser name from window object
   *
   * @returns a normalised string representation of the user's browser based on userAgent content
   */
  getUserBrowser() {
    const e = window.navigator.userAgent;
    return e.indexOf("Edg") > -1 ? "Edge" : e.indexOf("SamsungBrowser") > -1 ? "SamsungBrowser" : e.indexOf("Chrome") > -1 || e.indexOf("CriOS") > -1 ? "Chrome" : e.indexOf("Firefox") > -1 || e.indexOf("FxiOS") > -1 ? "Firefox" : e.indexOf("Safari") > -1 ? "Safari" : e.indexOf("MSIE") > -1 ? "Internet Explorer" : e.indexOf("OPR") > -1 || e.indexOf("Opera") ? "Opera" : "Unknown";
  }
  /**
   * Retrieve user's operating system name from the window object
   *
   * @returns a normalised string representation of the user's operating system based on userAgent content
   */
  getUserOS() {
    const e = window.navigator.userAgent;
    return e.indexOf("like Mac") > -1 ? "iOS" : e.indexOf("Mac") > -1 ? "Mac" : e.indexOf("Win") > -1 ? "Windows" : e.indexOf("Android") > -1 ? "Android" : e.indexOf("Linux") > -1 ? "Linux" : "Unknown";
  }
};
o(t, "urlEndpoint", "/v1/feedback");
let a = t;
export {
  a as default
};
